<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('material_style.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
            <v-row class="d-flex justify-end">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                          <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.code" :rules="stringRules" v-bind:label="$t('material_style.code')" outlined dense></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row no-gutters>
                              <v-col>
                                  <v-autocomplete v-model="selectMaterial" :items="materials" item-text="name" return-object outlined dense></v-autocomplete>
                              </v-col>
                          </v-row>
                          <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.color_name" :rules="stringRules" v-bind:label="$t('material_style.color_name')" outlined dense></v-text-field>
                              </v-col>
                          </v-row>
                          
                          <v-row no-gutters>
                              <v-col>
                                  <!-- <v-text-field v-model="editedItem.color_code" :rules="stringRules" v-bind:label="$t('material_style.color_code')"></v-text-field> -->
                                  <v-color-picker
                                    v-model="editedItem.color_code"
                                    :hide-canvas="false"
                                    :hide-inputs="false"
                                    :hide-mode-switch="true"
                                      mode="hexa"
                                    :show-swatches="false"></v-color-picker>
                              </v-col>
                          </v-row>

                          <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.description" v-bind:label="$t('material_style.description')" outlined dense></v-text-field>
                              </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <image-input v-model="image" fieldName="file" @input="uploadImage(image)">
                                    <div slot="activator">
                                    <v-avatar size="200px" tile v-ripple v-if="!image" class="grey lighten-3 mb-3">
                                        <span>{{ $t('design_item.image') }}</span>
                                    </v-avatar>
                                    <v-avatar size="200px" tile v-ripple v-else class="mb-3">
                                        <v-img :src="image.imageURL" max-width="200px" contain> </v-img>
                                    </v-avatar>
                                    </div>
                                </image-input>
                            </v-col>
                          </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                        <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </div>
        <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" sort-by="email" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-5">
                <v-row justify="start">
                  <v-col cols="12" sm="1">
                      <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="2">
                  </v-col>
                  
                  <v-col cols="12" sm="2">
                  </v-col>

                  <v-col cols="12" sm="7">
                      <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <v-icon  small class="mr-2"  @click="editItem(item)">
                    edit
                </v-icon>
                <v-icon  small @click="deleteItem(item)">
                    delete
                </v-icon>
            </template>

            <template v-slot:[`item.color_code`]="{ item }">
                <v-btn text icon :color="item.color_code">
                  <v-icon>lens</v-icon>
                </v-btn>

                <span>
                    {{item.color_code}}
                </span>
            </template>

            <template v-slot:[`item.images`]="{ item }">
              <v-avatar size="40px" tile v-ripple v-if="item.images.length > 0" class="mb-3">
                <!-- <img :src="genernateImagePath(item)"> -->
                <v-img :src="genernateImagePath(item)" max-width="40px" contain> </v-img>
              </v-avatar>
              <span v-else> Chưa có ảnh </span>
            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';
  import ImageInput from '@/components/ImageInput.vue';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('material_style.code'), value: 'code' },
        { text: i18n.t('material_style.material_id'), value: 'material.code' },
        { text: i18n.t('material_style.color_name'), value: 'color_name' },
        { text: i18n.t('material_style.color_code'), value: 'color_code' },
        { text: i18n.t('material_style.image'), value: 'images' },
        { text: i18n.t('material_style.description'), value: 'description' },
        { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      materials: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      selectMaterial: '',
      stringRules: [
        v => !!v || i18n.t('validate.not_empty'),
        // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ],
      image: null
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('material_style.add') : i18n.t('material_style.edit')
      },
    },
    components: {
       ImageInput: ImageInput
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

     created () {
      this.getData();
      this.getMaterialData();
    },

    methods: {
      initialize () {
      },

      editItem (item) {
        this.image = null;
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (item.images.length > 0) {
          this.image = {};
          this.image.id = item.images[0];
          this.image.imageURL = this.genernateImagePath(item);
        }
        this.dialog = true
        this.selectMaterial = item.material;
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        console.log(agree);
        if (agree) {
          const response =  await this.$http.delete("/materialStyle/" + item._id);
          if(response.data && response.data.success) {
              // console.log(response.data);
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = {};
          this.editedIndex = -1;
          this.image = null;
        }, 300)
      },

      async save () {
        const self = this;
        if (!this.editedItem.color_code || this.editedItem.color_code.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (!this.editedItem.color_name || this.editedItem.color_name.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (!this.editedItem.code || this.editedItem.code.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (this.editedIndex > -1) {
          try {
            const requestBody =  self.editedItem;
            requestBody.material = self.selectMaterial;
            if (this.image) {
              requestBody.images = [this.image.id];
            }

            // console.log(requestBody);
            const response = await this.$http.put('/materialStyle/' + self.editedItem._id,  requestBody);

            if (response.data && response.data.success) {
                // console.log(response.data);
                if (!this.image) {
                  self.editedItem.images = [];
                }

                Object.assign(this.desserts[this.editedIndex], this.editedItem);
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.update_success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        } else {
          try {
            const requestBody = self.editedItem;
            // console.log(self.editedItem.color_code);

            if (typeof self.editedItem.color_code !== 'string') {
                self.editedItem.color_code = self.editedItem.color_code.hex;
            }

            requestBody.material = self.selectMaterial;
            if (this.image) {
              requestBody.images = [this.image.id];
            }

            const response = await this.$http.post('/materialStyle', requestBody);

            if (response.data && response.data.success) {
                // console.log(response.data);
                if (!this.image) {
                  self.editedItem.images = [];
                }
                
                self.editedItem._id = response.data.data.id;
                this.desserts.push(self.editedItem);
                self.editedItem.index = this.desserts.length;
                self.editedItem = {};
                

                this.$fire({
                    title: i18n.t('common.success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        }
        this.close()
      },

      async getMaterialData() {
        try {
            const response = await this.$http.get('/material');
            if (response.data && response.data.success) {
                // console.log(response.data);
                this.materials = response.data.data;
                if (Array.isArray(this.materials) && this.materials.length > 0) {
                  this.selectMaterial = this.materials[0];
                }   
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      async getData() {
        try {
            const response = await this.$http.get('/materialStyle');
            if (response.data && response.data.success) {
              const contextArr = response.data.data;
              contextArr.forEach((item, index) =>item.index = index + 1);

              this.desserts = contextArr;
              this.loading = false;
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      async uploadImage(data) {
        if (data.formData != null) {
            const response =  await this.$httpUpload.post("/uploadImg/", data.formData);
            // console.log(response.data);
            if (response.data && response.data.id) {
                data.id = response.data.id;
            } else {
                alert(i18n.t('validate.request_error'));
            }
        }
      },

      genernateImagePath(item) {
        return process.env.VUE_APP_BASE_IMAGE + item.images[0];
      },
    }
  }
</script>